import { watch } from 'vue';

export function useScrollLock(state) {
  watch(state, (val) => {
    document.body.style.overflow = val ? 'hidden' : '';
  });
}
